"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Body2: function() {
        return _index.Body2;
    },
    body2ClassNames: function() {
        return _index.body2ClassNames;
    }
});
const _index = require("./components/presets/Body2/index");
